export default {
  setUser(state, { user }) {
    state.token = user.token;
  },
  logout(state) {
    state.token = null;
    state.user  = null;
    localStorage.removeItem("token");
  },
  setTheme(state, theme) {
    state.theme = theme;
    localStorage.setItem("portal_theme", theme);
  },
};
